import { TextField, TextFieldProps } from "@mui/material";

function NumberInput(props: TextFieldProps) {
  return (
    <TextField
      // sx={{ bgcolor: "var(--color-overlay)", ...sx }}
      variant="outlined"
      type="number"
      {...props}
    />
  );
}

export default NumberInput;
